<div [ngClass]="{'mobile': !isDesktop}" class="search-wrapper desktop-panel form-custom-design" #scrollContainer>
    <ng-container *ngIf="!isFilterSelect; else filterSelector">
        <div class="search-head">
            <!-- <span style="width: 32px;"></span>  ! -->

            <h1 i18n>Search</h1>

            <button class="close-sheet" (click)="onCloseEvent()">
                <img src="{{licenceService.getKey('close-icon')}}" alt="close-btn" />
            </button>
        </div>

        <div class="search-action">
            <div class="search-container" [ngClass]="{'focus': isInputFocused}">
                <ng-container *ngIf="isInputFocused">
                    <img class="search-img" src="{{licenceService.getKey('search-icon')}}" alt="icon-search" />
                </ng-container>

                <ng-container *ngIf="!isInputFocused">
                    <img class="search-img" src="{{licenceService.getKey('search-icon')}}" alt="icon-search" />
                </ng-container>
                
                <input [placeholder]="searchPlaceHolder" autocomplete="off" type="text" (input)="onSearchChange($event.target.value)" (focus)="onInputFocus()" (blur)="onInputBlur()" [value]="searchTerm" cdkFocusInitial>
                <button *ngIf="isInputSign" class="input-clear" (click)="onSearchChange('')"><img src="{{licenceService.getKey('close-icon')}}" alt="close-btn"/></button>
            </div>

            <div class="filter-container">
                <ng-container *ngFor="let filterItem of searchConfig.searchFilters">
                    <app-search-filter-selector [_filterItem]="filterItem" (choosedFilter)="onFilterChoose($event)"></app-search-filter-selector>
                </ng-container>
            </div>

            <app-search-filter-chips></app-search-filter-chips>
        </div>

        <div class="search-body" [attr.aria-busy]="searchStatus === 'loading'">
            <div class="result-container">
                <div class="result-header" aria-live="polite" aria-atomic="true">
                    <h1 style="text-transform: capitalize;" i18n>search results</h1>
                    <div class="count-container" *ngIf="gameList.length || searchStatus === 'complete'">
                        <p>{{resultCount}}</p>
                    </div>
                </div>
                <div class="search-status" role="alert" *ngIf="searchStatus === 'error'">
                    <p i18n>Sorry, something went wrong.</p>
                    <button type="button" class="retry-search" (click)="retrySearch()" i18n>Search</button>
                </div>
                <div class="game-container" *ngIf="gameList.length">
                    <ng-container *ngFor="let game of gameList; trackBy: trackGame">
                        <app-search-game-result (openGameEvent)="onOpenGame($event)" [data]="game"></app-search-game-result>
                    </ng-container>
                </div>
                <ng-container *ngIf="searchStatus === 'complete' && !gameList.length">
                        <div class="not-found">
                            <img class="not-found-img" src="{{licenceService.getKey('game-history-not-found')}}"/>
                            <h1 i18n>Nothing Found</h1>
                            <p i18n>Try searching for a different game</p>
                        </div>

                </ng-container>
            </div>
        </div>
    </ng-container>

    <ng-template #filterSelector>
        <app-search-filter-sheet (closeEvent)="onFilterSheetClose()" [_filterItemName]="filterItemName"></app-search-filter-sheet>
    </ng-template>
</div>
